import useDeleteProducts from "../api/useDeleteProducts";
import { Button } from "./generic/Button";

export const ProductListFooter = ({
  currentListId,
  products,
  openAddModal,
  openFavorites,
  openRecipes,
  openDeleteAllModal,
}) => {
  const { deleteProducts } = useDeleteProducts();

  const deletableProducts = products.filter((p) => p.checked).map((p) => p.id);

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        left: 0,
        minHeight: 0,
        boxSizing: "border-box",
        padding: "0.5rem",
        paddingBottom: "calc(0.5rem + env(safe-area-inset-bottom))",
        zIndex: 2,
        fontSize: "2rem",
        display: "flex",
        justifyContent: "flex-end",
        gap: "1rem",
        backgroundColor: "lightgray",
      }}
    >
      <Button onClick={openDeleteAllModal} disabled={!products.length}>
        💣
      </Button>
      <Button
        onClick={() => {
          deleteProducts(currentListId, deletableProducts);
        }}
        disabled={!products.filter(({ checked }) => checked).length}
      >
        🧹
      </Button>
      <Button onClick={openRecipes}>🧑‍🍳</Button>
      <Button onClick={openFavorites}>⭐</Button>
      <Button onClick={openAddModal}>➕</Button>
    </div>
  );
};
